import React from 'react';
import Hero from '../components/Hero/Hero';
import Categories from '../components/Categories/Categories';
import FeaturedProducts from '../components/FeaturedProducts/FeaturedProducts';

const Home = () => {
  return (
    <>
      <Hero />
      <Categories />
      <FeaturedProducts />
    </>
  );
};

export default Home;
